<template>
  <div class="DbAlliance">
    <BannerVideo :video-url="$StaticFileUrl + '/mp/video/alliance-video.mp4'">
      <div class="title wow fadeInDown" data-wow-duration="1s">助力企业私域流量留存与变现</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">丰富企业消费场景、提高用户留存、增加企业收益</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即体验</div>
      </div>
    </BannerVideo>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
export default {
  name: 'DbAlliance',
  components: {BannerVideo},
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
